import { assertMktoGlobal } from "./errors";

export default function() {
    assertMktoGlobal("mktoHiddenFields", () => mktoHiddenFields);
    return mktoHiddenFields;
}
